import { gql } from '@apollo/client'
import { PRODUCT_PRICE_FRAGMENT } from './ProductPriceFragment'
import { WHOLE_DISPLAY_AUDIT_FRAGMENT } from './WholeDisplayAuditFragment'
import { AUDIT_SCORE_FRAGMENT } from './ScoreFragments'
import { AUDIT_ANSWER_FRAGMENT } from './AuditAnswerFragment'
import { CR_COUNT_ITEM_FRAGMENT } from './CRCountItemFragment'

export const WHOLE_AUDIT_FRAGMENT = gql`
  fragment WholeAudit on Audit {
    id
    created
    saved
    dateCompleted
    displaysCompletedAt
    pricingCompletedAt
    surveyCompletedAt
    employee {
      firstName
      lastName
      id
      email
    }
    store {
      id
      storeChain
      name
      hasAllFormulas
      category
      address {
        address1
        city
        state
        postalCode
      }
    }
    status
    score {
      ...AuditScore
    }
    notes
    auditAnswers {
      ...AuditAnswer
    }
    displayAudits {
      ...WholeDisplayAudit
    }
    crCountItems {
      ...CRCountItem
    }
    productPrices {
      ...ProductPrice
    }
  }
  ${AUDIT_ANSWER_FRAGMENT}
  ${AUDIT_SCORE_FRAGMENT}
  ${WHOLE_DISPLAY_AUDIT_FRAGMENT}
  ${PRODUCT_PRICE_FRAGMENT}
  ${CR_COUNT_ITEM_FRAGMENT}
`
